import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
import { BilletYardInventoryPage } from "./BilletYardInventoryPage";
import { billetYardThemeExtension } from "./theme/billetYardTheme";

type Props = {};
const BilletsYardInventory = (props: Props) => {
  const baseTheme = useTheme();

  // Create extended theme with billet yard colors
  const extendedTheme = createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      ...billetYardThemeExtension.palette,
    },
  });

  return (
    <ThemeProvider theme={extendedTheme}>
      <BilletYardInventoryPage />
    </ThemeProvider>
  );
};
export default BilletsYardInventory;
